// 紹介リファラル用 Cookie 操作とURL処理

import { setCookie, getCookie, clearCookie, saveParamToCookie } from './cookie';

const COOKIE_NAME = 'kotomil_ref';
const MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30日

// 紹介コードをCookieに保存
export const setRefCookie = (code: string): void => {
    if (!code) return;
    const normalized = code.trim().toUpperCase();
    setCookie(COOKIE_NAME, normalized, MAX_AGE_SECONDS);
};

// 紹介コードをCookieから取得
export const getRefCookie = (): string | null => {
    return getCookie(COOKIE_NAME);
};

// 紹介コードをCookieから削除
export const clearRefCookie = (): void => {
    clearCookie(COOKIE_NAME);
};

// 現在のURLから紹介コードを取得してCookieに保存
export const saveRefFromCurrentUrl = (): void => {
    saveParamToCookie('ref', COOKIE_NAME, MAX_AGE_SECONDS);
};
